import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { AppLayout } from "../../shared/components/layout/app.layout";
import { SideBarComponent } from "../../shared/components/layout/sideBare.component";
import { NavbarComponent } from "../../shared/components/layout/navBare.component";

export const DashboardComponent: React.FC = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <AppLayout
      sidebar={
        <SideBarComponent
          mobileOpen={mobileOpen}
          onClose={() => setMobileOpen(false)}
        />
      }
      mainContent={<Outlet />}
      navBar={<NavbarComponent onMenuClick={() => setMobileOpen(true)} />}
    />
  );
};
